import { GraphQLClient } from 'graphql-request'
const AUTH_TOKEN = ''

const saleorGraphQLClient = new GraphQLClient(
  `${process.env.REACT_APP_SALEOR_API_URI}`,
  {
    headers: {
      Authorization: `Bearer ${AUTH_TOKEN}`,
    },
  },
)

export { saleorGraphQLClient }
